module.exports = __webpack_public_path__ + "static/media/deleteIcon.f338e3f0.svg";